import React, {useEffect, useState} from 'react';
import 'react-sliding-side-panel/lib/index.css';
import './BiddingSelectionForm.scss';
import SlidingPanel from "../SlidingPanel/index";
import Icons from "components/DmpIcons/icons";
import BiddingRuleManager from "../BiddingRule/BiddingRuleManager";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import DmpIcons from "components/DmpIcons/icons";

const CheckboxGroup = ({ options, onSelectionChange, onClosePlatform, selectedOption}) => {

    const handleCheckboxChange = (optionValue) => {
        if (selectedOption === optionValue) {
            onSelectionChange('');
        } else {
            onSelectionChange(optionValue);
            onClosePlatform();
        }
    };

    return (
        <div className="checkbox-grid">
            {options.map((option, index) => (
                <button
                    key={index}
                    className={`custom-button ${selectedOption === option.value ? 'selected' : ''}`}
                    onClick={() => handleCheckboxChange(option.value)}
                    aria-pressed={selectedOption === option.value}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};

const BiddingSelectionForm = ({ isOpen, onClose, action, title, onRefresh, currency }) => {
    const biddingOptions = [
        { label: 'Google Hotel Ads', value: 'GOOGLE_BIDDING_RULE' },
        { label: 'Tripadvisor', value: 'TRIPADVISOR_BIDDING_RULE' },
        { label: 'Trivago', value: 'TRIVAGO_BIDDING_RULE' },
    ];

    const [selectedBiddingRule, setSelectedBiddingRule] = useState('');
    const [isPlatformVisible, setIsPlatformVisible] = useState(true);
    const [isFormVisible, setIsFormVisible] = useState(true);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const showSnackbar = (message, severity='success') => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    }

    const handleFormVisibility = () => {
        setIsFormVisible((prev) => !prev);
    };

    const closePlatformSection = () => {
        setIsPlatformVisible(false);
    };

    const headerStyle = {
        backgroundColor: !selectedBiddingRule ? 'white' : '#61D5A9'
    };

    const selectedBiddingRuleLabel = biddingOptions.find(
        option => option.value === selectedBiddingRule)?.label + " Bidding" || '';

    // Fonction pour réinitialiser les états
    const resetPanel = () => {
        setSelectedBiddingRule('');
        setIsPlatformVisible(true);
        setIsFormVisible(true);
    };

    const togglePlatformSection = () => {
        setIsPlatformVisible((prev) => !prev);
    };

    // Utiliser un effet pour réinitialiser lorsque le panneau s'ouvre
    useEffect(() => {
        if (!isOpen) {
            resetPanel(); // Réinitialiser les états lorsque le panneau se ferme
        }
    }, [isOpen]);

    const handleClose = () => {
        onClose(); // Fermer le panneau
    };

    return (
        <div>
        <SlidingPanel isOpen={isOpen} onClose={handleClose}>
            <div className="bidding-panel-container">
                <div className="platform-container" style={{ width: '100%' }}>
                    <div className="panel-header" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <div
                            onClick={handleClose}
                            className="close-panel-circle"
                        >
                            <DmpIcons.ActionsIcons.ClosePanelFillColorIcon className="close-panel-icon" />
                        </div>
                        <h2 style={{
                            fontSize: '20px',
                            textAlign: 'left',
                            fontWeight: 400,
                            fontFamily: 'Quincy CF, serif',
                        }}>
                            {title}
                        </h2>
                    </div>
                    <div className="bidding-center-platform-selection">
                        <div
                            className={`bidding-center-collapsible-header ${isPlatformVisible ? 'expanded' : ''}`}
                            style={headerStyle}
                            onClick={togglePlatformSection}
                        >
                            <h2 className="platform-title">1. SELECT BIDDING RULE TYPE</h2>
                            <span className="arrow-icon">
                                <img
                                    src={Icons.AccessibilityIconsSVG.ThinDownArrowIconSVG}
                                    alt="Arrow Down"
                                    className={isPlatformVisible ? 'rotate-up' : 'rotate-down'}
                                />
                              </span>
                        </div>
                        {isPlatformVisible && (
                            <div className="collapsible-section">
                                <CheckboxGroup
                                    options={biddingOptions}
                                    onSelectionChange={setSelectedBiddingRule}
                                    onClosePlatform={closePlatformSection}
                                    selectedOption={selectedBiddingRule}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {selectedBiddingRule && (
                    <div className="form-container">
                        <div className="platform-container">
                            <div className="collapsible-form">
                                <div
                                    className={`bidding-center-collapsible-header ${isFormVisible ? 'expanded' : ''}`}
                                    onClick={handleFormVisibility}
                                >
                                    <h2 className="platform-title">2. CREATE | {selectedBiddingRuleLabel.toUpperCase()}</h2>
                                    <span className="arrow-icon">
                                        <img
                                            src={Icons.AccessibilityIconsSVG.ThinDownArrowIconSVG}
                                            alt="Arrow Down"
                                            className={isFormVisible ? 'rotate-up' : 'rotate-down'}
                                        />
                                    </span>
                                </div>
                                {isFormVisible && (
                                    <BiddingRuleManager
                                        action={action}
                                        onClose={handleClose}
                                        onRefresh={onRefresh}
                                        biddingRuleData={{ bidding_rule_type: selectedBiddingRule, status: 'ENABLED', currency: currency }}
                                        showSnackbar={showSnackbar}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </SlidingPanel>
        <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={() => setSnackbarOpen(false)}
        >
            <Alert
                onClose={() => setSnackbarOpen(false)}
                severity={snackbarSeverity}
                sx={{ width: '100%' }}
            >
                {snackbarMessage}
            </Alert>
        </Snackbar>
    </div>
    );
};

export default BiddingSelectionForm;
